import React from 'react';
import { useSelector } from 'react-redux';

const FlowmaPowered = ({ 
    className = '', 
    language: languageProp, 
    invert = true, 
    withLogoBackground = false // New option: Toggle the white sphere
}) => {
    // Logic: 1. Redux -> 2. Prop -> 3. Default 'en'
    const systemData = useSelector((s) => s.systemData || {});
    const language = systemData.language || languageProp || 'en';
    
    const isHebrew = language === 'he';
    const dir = isHebrew ? 'rtl' : 'ltr';
    const poweredByText = isHebrew ? 'מופעל על ידי' : 'Powered by';
    const flowmaName = 'flowma';

    // Dynamic URL
    const targetUrl = `https://www.flowma.co.il?lan=${language}`;

    // CONTAINER STYLES
    const containerClasses = invert 
        ? 'border-white/20 bg-white/10 text-white hover:bg-white/20' 
        : 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50';

    // LOGO STYLES
    // If withLogoBackground is TRUE -> White ball, normal logo colors.
    // If withLogoBackground is FALSE -> No ball, inverted logo (if invert is true).
    const logoClasses = withLogoBackground
        ? "h-6 w-auto bg-white rounded-full p-1"
        : `h-6 w-auto ${invert ? 'invert' : ''}`;

    return (
        <div dir={dir} className={`flex justify-center w-full my-4 ${className}`}>
            <a
                href={targetUrl}
                rel="dofollow"
                aria-label={`Powered by ${flowmaName}`}
                className={`
                    inline-flex items-center gap-2 rounded-full border px-3 py-1 text-sm backdrop-blur 
                    transition hover:shadow 
                    ${containerClasses}
                `}
            >
                <span className="opacity-80">{poweredByText}</span>
                
                <img
                    src="https://sawpy-assets.s3.us-east-2.amazonaws.com/logos/flowma-it.svg"
                    alt="Flowma logo"
                    className={logoClasses}
                    loading="lazy"
                />
                
                <span className="font-semibold">{flowmaName}</span>
            </a>
        </div>
    );
};

export default FlowmaPowered;